<!-- SET AS DEFAULT TOGGLE -->
<div>
  <app-result-set-config-btn *ngIf="resultSetConf"
                             [resultSetConfig]="resultSetConf"
                             (toggleChangeNotifier)="onResultSetDefaultChange()"
  >
  </app-result-set-config-btn>
</div>
<!-- END SET AS DEFAULT TOGGLE -->
<!--START SELECTION BOXES-->
<div class="row fl" *ngIf="addResults">
  <!-- Period Select -->
  <div class="fl-item">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="flow-diagram-period_select"
        [(value)]="periodType"
        placeholder="{{'RESULTS.GENERAL.SET_PERIOD' | anessaTranslation: trigger}}"
        disableOptionCentering
        (valueChange)="onDropdownChange()"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of periodCategories"
          [value]="opt.value">{{ opt.translationId | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <!-- Measurement System Select -->
  <div class="fl-item" *ngIf="!hideMeasurementSelect">
    <mat-form-field floatLabel="never" class="anessa-dropdown">
      <mat-select
        id="flow-diagram-measurement_select"
        [(value)]="techUnitType"
        placeholder="{{'RESULTS.GENERAL.SET_UNIT_TYPES' | anessaTranslation: trigger}}"
        disableOptionCentering
        (valueChange)="onDropdownChange()"
        panelClass="anessa-dropdown-panel">
        <mat-option
          *ngFor="let opt of techUnitTypes"
          [value]="opt.value">{{ opt.translationId | anessaTranslation: trigger }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<!--END SELECTION BOXES-->
<div a id="main-creator-div" cdkScrollable>
  <div id="popper-div" #popperDiv class="border-shadow"></div>
  <p>
    <span *ngIf="!addResults">{{'PFD.DESCRIPTION.0' | anessaTranslation: trigger}}</span>
    {{'PFD.DESCRIPTION.1' | anessaTranslation: trigger}}
    {{'PFD.DESCRIPTION.2' | anessaTranslation: trigger}}
  </p>
  <div class="flex-container">
    <div id="cy" class="border-shadow flex-box"></div>
  </div>

  <ng-container *ngIf="!hideSpacingSlider">
    <p>{{'PFD.FLOW_SPACING' | anessaTranslation: trigger}}</p>
    <mat-slider
      discrete
      [min]="0.1"
      [max]="4"
      [step]="0.05"
      ><input matSliderThumb [(ngModel)]="spacingFactor" (change)="initGraph()"/></mat-slider>
  </ng-container>

  <div *ngIf="!hideSaveButtons" class="bottom-buttons">
    <div class="save-buttons">
      <button mat-button id="saveChartToPc_button" (click)="saveGraphic()" class="btn-green">{{'PFD.SAVE_CHART_TO_PC' | anessaTranslation: trigger}}</button>
    </div>
  </div>
  <div class="spacer"></div>

  <canvas id="canvas" width="1024" height="1024" hidden
            style="border: 1px solid black; background-color: white;">
  </canvas>

</div>
